import { AvatarType } from 'components/shared/User/Avatar'

export enum ActionType {
  RESET_AUTH = 'RESET_AUTH',

  SET_USER = 'SET_USER',

  GET_AGENCY = 'GET_AGENCY',
  PATCH_AGENCY = 'PATCH_AGENCY',
  SET_AGENCY = 'SET_AGENCY',

  GET_CLIENT_COMPANY = 'GET_CLIENT_COMPANY',
  SET_CLIENT_COMPANY = 'SET_CLIENT_COMPANY',
}

export interface IUser {
  id: number
  exp: number
  iat: number
  agencyId?: number
  clientId?: number
  /**
   * Метки (группы) пользователя. Тут и роли и пометки клиентский он, агентский или еще какой-то.
   * В целом просто куча строк, которые будт позволять делать однородные проверки на интерфейсе и бекенде
   */
  tags: string[]
}

export interface IPatchAgency {
  name: string
  logo: any
}

export interface IAgency extends IPatchAgency {
  id: number
}

interface IClientManager extends AvatarType {
  id: number
  title: string
}

export interface IClientCompany {
  id: number
  logo: string
  name: string
  url: string
  createdAt: string
  email: string
  accountManager: IClientManager
  managers: IClientManager[]
}
